import React, { createContext, useContext, useState } from 'react';

const PopupContext = createContext();

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};

export const PopupProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [popupContext, setPopupContext] = useState('default');

  const openPopup = (context = 'default') => {
    setPopupContext(context);
    setIsOpen(true);
  };
  
  const closePopup = () => {
    setIsOpen(false);
    // Reset context after a delay to allow for smooth closing animation
    setTimeout(() => setPopupContext('default'), 300);
  };

  return (
    <PopupContext.Provider value={{ isOpen, openPopup, closePopup, popupContext }}>
      {children}
    </PopupContext.Provider>
  );
};